<template>
  <RemissionsPickingPacking />
</template>

<script>
import RemissionsPickingPacking from '@/views/admin/remissions/PickingPacking.vue';

export default {
  name: 'OperadorPickingPacking',
  components: { RemissionsPickingPacking },
};
</script>
